import React from "react";
import "./Startups.css";
import VirtualCards from "../../assests/send_money.png";
import PhoneMockup from "../PhoneMockup/PhoneMockup";
import { Link } from "react-router-dom";

const perks = [
  {
    title: "Bank-grade Security",
    desc: "Your data and funds are protected with end-to-end encryption and multi-layer fraud detection.",
  },
  {
    title: "24/7 Customer Support",
    desc: "Our team is always available — live chat, email, and phone support whenever you need us.",
  },
  {
    title: "Rewards & Loyalty",
    desc: "Earn cashback and rewards on every transfer, bill payment, and crypto transaction.",
  },
];

const Startups = () => {
  return (
    <section className="startups">
      <div className="startups-inner">
        <div className="startups-left">
          <span className="startups-label">Why Sendcheap</span>
          <h2 className="startups-title">
            Join 10,000+ users<br />
            <span className="startups-accent">growing with us.</span>
          </h2>

          <div className="startups-perks">
            {perks.map((p, i) => (
              <div className="startups-perk" key={i}>
                <div className="sp-check">&#10003;</div>
                <div>
                  <h4 className="sp-title">{p.title}</h4>
                  <p className="sp-desc">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="startups-actions">
            <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
              <button className="startups-btn-fill">Get Started &rarr;</button>
            </a>
            <Link to="/">
              <button className="startups-btn-ghost">Learn More</button>
            </Link>
          </div>
        </div>

        <div className="startups-right">
          <div className="startups-phone-bg"></div>
          <PhoneMockup
            screenshot={VirtualCards}
            alt="Virtual cards screen"
            size="lg"
            className="startups-pm"
          />
        </div>
      </div>
    </section>
  );
};

export default Startups;
